import { Button } from '@/components/ui/button';
import OwnInnIcon from '@/components/icons/OwnInnIcon';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';
import useMediaQuery from '@/hooks/useMediaQuery';
import { AppConfig } from '@/config/app.config';
import { cn } from '@/lib/utils';
import { useRegistrationConfirmApi } from '@/features/identity/hooks/useRegistrationConfirmApi';

const RegistrationConfirmForm = () => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const isMobile = useMediaQuery(AppConfig.mediaQueries.mobile);
	const [searchParams] = useSearchParams();

	const token = searchParams.get('token') ?? '';
	const tenant = searchParams.get('tenant') ?? '';

	const { confirmRegistrationStatus } = useRegistrationConfirmApi({
		token,
		tenant,
	});

	const options = {
		success: {
			message: t('auth.registrationConfirmForm.text.success.message'),
			description: t(
				'auth.registrationConfirmForm.text.success.description',
			),
		},
		error: {
			message: t('auth.registrationConfirmForm.text.error.message'),
			description: t(
				'auth.registrationConfirmForm.text.error.description',
			),
		},
	};

	return (
		<div
			className={cn(
				'my-auto flex-1 flex flex-col gap-6 rounded-2.5xl bg-popover-10',
				isMobile ? 'grow' : 'max-w-[20.5rem]',
			)}>
			<div className='flex flex-col items-center gap-4 text-center'>
				<OwnInnIcon className='size-11' />
				<div className='w-[20.5rem] flex flex-col items-center gap-2'>
					<h3 className='text-2xl font-semibold select-none'>
						{confirmRegistrationStatus === 200
							? options.success.message
							: options.error.message}
					</h3>
					<p className='text-sm text-popover-800 font-medium'>
						{confirmRegistrationStatus === 200
							? options.success.description
							: options.error.description}
					</p>
					<div className='flex justify-center gap-1.5'>
						<p className='text-sm text-popover-800 font-medium'>
							{t('elements.buttons.goBack')}
						</p>
						<Button
							onClick={() => navigate('/auth/login')}
							type='button'
							variant='link'
							className='p-0 hover:text-popover-800 active:text-popover-600'>
							{t('elements.buttons.login')}
						</Button>
					</div>
				</div>
			</div>
		</div>
	);
};

export default RegistrationConfirmForm;
